var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.10352e-05C4.48 6.10352e-05 0 4.48006 0 10.0001C0 15.5201 4.48 20.0001 10 20.0001C15.52 20.0001 20 15.5201 20 10.0001C20 4.48006 15.52 6.10352e-05 10 6.10352e-05ZM9 15.0001V13.0001H11V15.0001H9ZM9 5.00006V11.0001H11V5.00006H9Z",
    fill: "#171D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.b563195778335536a3e2da5ee5a2af56.svg";
export { ForwardRef as ReactComponent };